import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import api from '@/lib/api';
import { toast } from 'sonner';
import { monthRange } from '../reportUtils';
import { useTenantCompanyName, ReportToolbar, ReportDocument, fmtRp } from '../ReportShell';

function CompareCard({ title, periodLabel, p }) {
  return (
    <div className="acct-rpt-compare-card">
      <h4>{title}</h4>
      <table>
        <tbody>
          <tr>
            <td>Total pendapatan</td>
            <td>{fmtRp(p.revenue_total)}</td>
          </tr>
          <tr>
            <td>Total beban</td>
            <td>{fmtRp(p.expense_total)}</td>
          </tr>
          <tr className="font-bold bg-slate-50">
            <td>Laba (rugi) bersih</td>
            <td className={p.net_income >= 0 ? 'text-emerald-800' : 'text-red-700'}>{fmtRp(p.net_income)}</td>
          </tr>
        </tbody>
      </table>
      <p className="border-t border-slate-200 px-3 py-2 text-center text-[10px] uppercase tracking-wider text-slate-500">{periodLabel}</p>
    </div>
  );
}

export default function ReportCompare() {
  const company = useTenantCompanyName();
  const { start: mStart, end: mEnd } = monthRange();
  const [p1s, setP1s] = useState(mStart);
  const [p1e, setP1e] = useState(mEnd);
  const [p2s, setP2s] = useState(mStart);
  const [p2e, setP2e] = useState(mEnd);
  const [cmp, setCmp] = useState(null);

  const loadCmp = () => {
    api
      .get('/tenant/accounting/reports/compare', { params: { p1_start: p1s, p1_end: p1e, p2_start: p2s, p2_end: p2e } })
      .then((r) => setCmp(r.data))
      .catch(() => toast.error('Gagal bandingkan'));
  };

  return (
    <div>
      <ReportToolbar>
        <div className="flex flex-wrap items-end gap-3">
          <div className="flex flex-col gap-1">
            <Label className="text-xs font-semibold text-slate-600">Periode 1 — mulai</Label>
            <Input type="date" value={p1s} onChange={(e) => setP1s(e.target.value)} className="h-9 w-[130px]" />
          </div>
          <div className="flex flex-col gap-1">
            <Label className="text-xs font-semibold text-slate-600">Periode 1 — akhir</Label>
            <Input type="date" value={p1e} onChange={(e) => setP1e(e.target.value)} className="h-9 w-[130px]" />
          </div>
          <div className="flex flex-col gap-1">
            <Label className="text-xs font-semibold text-slate-600">Periode 2 — mulai</Label>
            <Input type="date" value={p2s} onChange={(e) => setP2s(e.target.value)} className="h-9 w-[130px]" />
          </div>
          <div className="flex flex-col gap-1">
            <Label className="text-xs font-semibold text-slate-600">Periode 2 — akhir</Label>
            <Input type="date" value={p2e} onChange={(e) => setP2e(e.target.value)} className="h-9 w-[130px]" />
          </div>
        </div>
        <Button type="button" onClick={loadCmp} className="h-9">
          Bandingkan
        </Button>
      </ReportToolbar>

      {cmp && (
        <ReportDocument companyName={company} title="PERBANDINGAN LABA RUGI" subtitle="Dua periode berdampingan (ringkas)">
          <div className="acct-rpt-compare-grid">
            <CompareCard title="Periode 1" periodLabel={`${p1s} s.d. ${p1e}`} p={cmp.period1} />
            <CompareCard title="Periode 2" periodLabel={`${p2s} s.d. ${p2e}`} p={cmp.period2} />
          </div>
          {cmp.delta && (
            <div className="acct-rpt-delta">
              <p className="mb-2 font-bold text-slate-900">Varians (Periode 2 − Periode 1)</p>
              <table className="acct-rpt-table">
                <tbody>
                  <tr>
                    <td>Δ Pendapatan</td>
                    <td className="acct-rpt-num font-semibold">{fmtRp(cmp.delta.revenue)}</td>
                  </tr>
                  <tr>
                    <td>Δ Beban</td>
                    <td className="acct-rpt-num font-semibold">{fmtRp(cmp.delta.expense)}</td>
                  </tr>
                  <tr>
                    <td>Δ Laba bersih</td>
                    <td className="acct-rpt-num font-semibold">{fmtRp(cmp.delta.net_income)}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          )}
        </ReportDocument>
      )}

      {!cmp && <div className="acct-rpt-empty">Atur empat tanggal lalu klik <strong>Bandingkan</strong>.</div>}
    </div>
  );
}
